/**
 * Shadow-piercing implementation of closest
 * @param selector 
 * @param target 
 * @returns 
 */
export function closest(selector: string, target: Element): Element | null {
  const found = target.closest(selector);

  if (found) {
    return found;
  }

  const root = target.getRootNode();

  if (root === document || !(root instanceof ShadowRoot)) {
    return null;
  }

  return closest(selector, root.host);
}
